import InvoicesTable from './InvoicesTable/InvoicesTable';
import BillingSummary from './BillingSummary/BillingSummary';
import BillingSummaryPage from './BillingSummaryPage/BillingSummaryPage';
import MakePaymentPage from './MakePaymentPage/MakePaymentPage';
import AutomaticPaymentPage from './AutomaticPaymentPage/AutomaticPaymentPage';
import PaymentInfoExt from './PaymentInfo/PaymentInfoExt';


const billingComponentMap = {
    InvoicesTable: { component: 'InvoicesTable' },
    BillingSummary: { component: 'BillingSummary' },
    AutomaticPaymentPage:{component:'AutomaticPaymentPage'},
    PaymentInfoExt:{component: "PaymentInfoExt"}
};

const billingAdditionalComponents = {
    InvoicesTable,
    BillingSummary,
    AutomaticPaymentPage,
    PaymentInfoExt
};

export {
    InvoicesTable,
    BillingSummary,
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents,
    AutomaticPaymentPage,
    PaymentInfoExt
};
